module.exports = __webpack_public_path__ + "static/media/SharedByYou.e6b627b3.svg";